import type { GivePortalSelfAssessmentBody, PortalSelfAssessment } from '../models/portal-session'
import type { PortalDraft } from '../composables/use-portal-draft'

const REFLEXION_MAX_LENGTH = 2000

export const buildSelfAssessmentBody = (
  questionnaire: PortalSelfAssessment,
  draft: PortalDraft,
): GivePortalSelfAssessmentBody | null => {
  const answers: GivePortalSelfAssessmentBody['answers'] = []

  for (const indikator of questionnaire.indikatoren) {
    const value = draft.indikatorAnswers[indikator.id]
    if (value == null) {
      return null
    }
    const onScale = questionnaire.scale.items.some((item) => item.value === value)
    if (!onScale) {
      return null
    }
    answers.push({ indikatorId: indikator.id, value })
  }

  const reflexionAnswers: GivePortalSelfAssessmentBody['reflexionAnswers'] = []
  for (const question of questionnaire.reflexionQuestions) {
    const text = (draft.reflexionTexts[question.id] ?? '').trim().slice(0, REFLEXION_MAX_LENGTH)
    if (!text) {
      continue
    }
    reflexionAnswers.push({ reflexionQuestionId: question.id, text })
  }

  return { answers, reflexionAnswers }
}
